import { render, staticRenderFns } from "./loginp.vue?vue&type=template&id=32e82d66&scoped=true&"
import script from "./loginp.vue?vue&type=script&lang=js&"
export * from "./loginp.vue?vue&type=script&lang=js&"
import style0 from "./loginp.vue?vue&type=style&index=0&id=32e82d66&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e82d66",
  null
  
)

export default component.exports